"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
// based on logger.js
var logData = [];
exports.logger = {
    logClient: {
        log: function (data) {
            logData.push(data);
        }
    },
    getLog: function () {
        return logData.join('\n');
    }
};
